<template>
  <div class="custom-view-wrapper">
    <div class="dg-title">{{ trans("SelectContractForm.title") }}</div>

      <div v-if="publishedContracts.length > 0">
        <div class="radio radio-success" v-for="item in publishedContracts" :key="item.id">
          <input type="radio" :id="item.id" :name="item.name" :value="item.id" v-model="value" aria-invalid="false">
          <label :for="item.id">{{ item.name }}</label>
        </div>
      </div>
      <div v-else>
        <p>{{ trans("SelectContractForm.no_data") }}</p>
      </div>

      <button @click="selectContract" class="btn btn-primary btn-cons m-t-15 pull-left btn-confirm" v-bind:disabled="!value">
        {{ trans("SelectContractForm.buttons.confirm") }}
      </button>
      <button @click="closeSelectContractForm" class="btn btn-default m-t-15 pull-right btn-cancel">
        {{ trans("SelectContractForm.buttons.close") }}
      </button>
      <div class="clearfix"></div>
  </div>
</template>

<script>
import DialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';
import i18n from '@/lang';

export default {
  name: "SelectContractForm",
  mixins: [DialogMixin],
  data: function() {
    return {
      value: null,
    }
  },
  methods: {
    trans(text) {
      return i18n.t(text);
    },
    closeSelectContractForm() {
      this.$emit('close');
    },
    selectContract() {
      this.proceed(this.value);
    }
  },
  computed: {
    publishedContracts() {
      return this.options.contractTemplates;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/offers/SelectContractForm.vue